import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaApple, FaArrowRight, FaBookOpen, FaGooglePlay, FaSearch } from "react-icons/fa";
import guides from "./guideData";
import "./Guide.css";

const categories = ["All guides", "Getting started", "Customers", "Business owners"];
const guideCategory = (guide) => guide.audience === "Business owners" ? "Business owners" : ["installation", "getting-started"].includes(guide.slug) ? "Getting started" : "Customers";

export default function Guide() {
  const [query, setQuery] = useState("");
  const [category, setCategory] = useState("All guides");
  const filtered = [...guides].sort((a, b) => a.order - b.order).filter((guide) =>
    (category === "All guides" || guideCategory(guide) === category) &&
    [guide.title, guide.description, guide.audience, ...guide.steps.flat()].join(" ").toLowerCase().includes(query.trim().toLowerCase())
  );
  return (
    <section className="guide-page">
      <div className="guide-hero">
        <p className="guide-eyebrow">The SnapConX help centre</p>
        <h1>A little guidance.<br />A confident next step.</h1>
        <p>From your first download to your next booking. Find practical steps for using the app and managing your business.</p>
      </div>
      <section className="guide-download-app" aria-labelledby="guide-download-title">
        <div>
          <h2 id="guide-download-title">Get the SnapConX app</h2>
          <p>Download the app, then follow the guides below.</p>
        </div>
        <div className="guide-store-links">
          <a href="https://apps.apple.com/us/app/snapconx/id6755649903" target="_blank" rel="noopener noreferrer" className="guide-store-link">
            <FaApple aria-hidden="true" /><span><small>Download on the</small>App Store</span>
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.authurton.dotdashmobile" target="_blank" rel="noopener noreferrer" className="guide-store-link">
            <FaGooglePlay aria-hidden="true" /><span><small>Get it on</small>Google Play</span>
          </a>
        </div>
      </section>
      <div className="guide-start">
        <div><p className="guide-eyebrow">New here?</p><h2>Start with the essentials</h2><p>Learn how to browse local businesses before creating an account.</p></div>
        <Link className="guide-link" to="/guide/getting-started">Get started <FaArrowRight aria-hidden="true" /></Link>
      </div>
      <div className="guide-tools">
        <label className="guide-search"><span>Search the guides</span><div><FaSearch aria-hidden="true" /><input type="search" value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Try booking, profile or availability" /></div></label>
        <div className="guide-filters" role="group" aria-label="Filter guides by audience">{categories.map((item) => <button key={item} aria-pressed={category === item} onClick={() => setCategory(item)}>{item}</button>)}</div>
      </div>
      <p className="guide-results" role="status">{filtered.length} {filtered.length === 1 ? "guide" : "guides"} to explore</p>
      <div className="guide-grid">{filtered.map((guide) => (
        <Link to={`/guide/${guide.slug}`} className="guide-card" key={guide.slug}>
          <div className="guide-card-top"><div className="guide-card-icon" aria-hidden="true"><FaBookOpen /></div><span>{guide.steps.length} steps · {guide.file ? 'PDF available' : 'Online guide'}</span></div>
          <span className="guide-card-audience">{guideCategory(guide)}</span>
          <h2>{guide.title}</h2><p>{guide.description}</p>
          <span className="guide-link">Read guide <FaArrowRight aria-hidden="true" /></span>
        </Link>
      ))}</div>
      {filtered.length === 0 && <div className="guide-empty"><h2>No matching guides</h2><p>Try a broader search or choose another category.</p><button onClick={() => { setQuery(""); setCategory("All guides"); }}>Show all guides</button></div>}
      <aside className="guide-support"><div><h2>Still need a hand?</h2><p>Explore common questions or tell us where you got stuck.</p></div><Link to="/FAQ">Read FAQs</Link><Link to="/feedback">Send feedback</Link></aside>
    </section>
  );
}

